var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Content",
        { attrs: { id: "users" } },
        [
          _c(
            "div",
            { attrs: { slot: "search" }, slot: "search" },
            [
              _c("Search", {
                attrs: {
                  model: _vm.search,
                  elem: _vm.searchElem,
                  "btn-loading": _vm.list.loading,
                },
                on: { "on-search": _vm.handleDataList },
              }),
            ],
            1
          ),
          _c("ITable", {
            ref: "list",
            attrs: {
              stripe: "",
              columns: _vm.columns,
              loading: _vm.list.loading,
              data: _vm.list.data,
              total: _vm.list.total,
            },
            on: { "on-page-change": _vm.handleDataList },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }